export const detailsPageConnectData = {
  title: (
    <>
      This is how we
      <br /> <span className='--blue'>connect the unconnected.</span>
    </>
  ),
  img: 'https://storage.googleapis.com/fk-gp/websiteAssets/fankave/connect-the-unconnect.webp',
};
